module.exports = __webpack_public_path__ + "static/full02-e95a365c12eeb6db262f4596144aa065.png";